module.exports = __webpack_public_path__ + "static/media/tick.6ecf2ffd.svg";